import Slider from "./Slider";

const SkeletonLoader = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: React.ReactNode;
}) => {
  return (
    <>
      <Slider animate={isLoading ? "hidden" : "visible"} custom={{}}>
        {children}
      </Slider>
      <Slider animate={isLoading ? "visible" : "hidden"} custom={{}}>
        <div
          role="status"
          className={`animate-pulse ${isLoading ? "" : "hidden"}`}
        >
          <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
          <span className="sr-only">Loading...</span>
        </div>
      </Slider>
    </>
  );
};

export default SkeletonLoader;
